import { useContext } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ObservationConfig } from '@cognite/apm-client';

import { useFDMServices } from '../../../../../providers/fdm-services/fdm-services.context';
import { MutationKeys, QueryKeys } from '../../../../../utils/queryKeys';

import { UseUpsertObservationConfigMutationContext } from './use-upsert-observation-config-mutation.context';

export const useUpsertObservationConfig = () => {
  const { captureException } = useContext(
    UseUpsertObservationConfigMutationContext
  );
  const { apmClient } = useFDMServices();
  const queryClient = useQueryClient();

  return useMutation<
    ObservationConfig[] | undefined,
    Error,
    ObservationConfig[]
  >({
    mutationFn: async (observationConfigToUpsert) => {
      const {
        data: { items: observationConfig },
      } = await apmClient.observationConfig.upsert(observationConfigToUpsert);
      return observationConfig;
    },
    onError: (err) => {
      captureException(err, {
        level: 'error',
        tags: {
          mutationKey: MutationKeys.USE_OBSERVATION_CONFIG_UPSERT,
        },
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.OBSERVATION_CONFIG],
      });
    },
    mutationKey: [MutationKeys.USE_OBSERVATION_CONFIG_UPSERT],
  });
};
